<template lang="html">
  <div class="wcc auth">
    <h2>Choose</h2>
    <div class="wcc buttons">
      <button type="wcc button" class="button" v-hammer:tap="chooseLogin">Login</button><button type="wcc button" class="button" v-hammer:tap="chooseSignUp">Sign Up</button>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      chooseLogin() {
        this.$store.dispatch('auth/chooseLogin')
      },
      chooseSignUp() {
        this.$store.dispatch('auth/chooseSignUp')
      }
    }
  }
</script>
<style lang="scss">
</style>